var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZeroCost2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63672 14.0117C2.63672 7.73016 7.73013 2.63672 14.0117 2.63672C20.2933 2.63672 25.3867 7.73016 25.3867 14.0117C25.3867 20.2933 20.2933 25.3867 14.0117 25.3867C7.73013 25.3867 2.63672 20.2933 2.63672 14.0117ZM14.0117 4.38672C8.69662 4.38672 4.38672 8.69665 4.38672 14.0117C4.38672 19.3268 8.69662 23.6367 14.0117 23.6367C19.3268 23.6367 23.6367 19.3268 23.6367 14.0117C23.6367 8.69665 19.3268 4.38672 14.0117 4.38672Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63672 14.0117C2.63672 7.73016 7.73013 2.63672 14.0117 2.63672C20.2933 2.63672 25.3867 7.73016 25.3867 14.0117C25.3867 20.2933 20.2933 25.3867 14.0117 25.3867C7.73013 25.3867 2.63672 20.2933 2.63672 14.0117ZM14.0117 4.38672C8.69662 4.38672 4.38672 8.69665 4.38672 14.0117C4.38672 19.3268 8.69662 23.6367 14.0117 23.6367C19.3268 23.6367 23.6367 19.3268 23.6367 14.0117C23.6367 8.69665 19.3268 4.38672 14.0117 4.38672Z",
    fill: "url(#paint0_linear_560_360)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8098 10.9434C12.4049 10.9434 11.9931 11.3102 11.9931 11.8534C11.9931 12.2647 12.0814 12.4131 12.1256 12.4694C12.1781 12.5363 12.2832 12.6196 12.5641 12.7198L16.0782 13.9457C16.4893 14.092 16.9591 14.3217 17.3101 14.7711C17.6687 15.2304 17.8148 15.8033 17.8148 16.4617C17.8148 17.894 16.7062 19.1217 15.2481 19.1217H13.0548C11.462 19.1217 10.2314 17.7829 10.2314 16.205C10.2314 15.7218 10.6232 15.33 11.1064 15.33C11.5897 15.33 11.9814 15.7218 11.9814 16.205C11.9814 16.8906 12.501 17.3717 13.0548 17.3717H15.2481C15.6567 17.3717 16.0648 17.0128 16.0648 16.4617C16.0648 16.0585 15.9775 15.908 15.9308 15.8482C15.8765 15.7786 15.7692 15.6936 15.4938 15.5953L11.9797 14.3694C11.5741 14.225 11.1021 13.9995 10.7493 13.5502C10.3882 13.0904 10.2431 12.5154 10.2431 11.8534C10.2431 10.4366 11.348 9.19336 12.8098 9.19336H15.0031C16.596 9.19336 17.8264 10.5322 17.8264 12.11C17.8264 12.5933 17.4347 12.985 16.9514 12.985C16.4682 12.985 16.0764 12.5933 16.0764 12.11C16.0764 11.4245 15.557 10.9434 15.0031 10.9434H12.8098Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8098 10.9434C12.4049 10.9434 11.9931 11.3102 11.9931 11.8534C11.9931 12.2647 12.0814 12.4131 12.1256 12.4694C12.1781 12.5363 12.2832 12.6196 12.5641 12.7198L16.0782 13.9457C16.4893 14.092 16.9591 14.3217 17.3101 14.7711C17.6687 15.2304 17.8148 15.8033 17.8148 16.4617C17.8148 17.894 16.7062 19.1217 15.2481 19.1217H13.0548C11.462 19.1217 10.2314 17.7829 10.2314 16.205C10.2314 15.7218 10.6232 15.33 11.1064 15.33C11.5897 15.33 11.9814 15.7218 11.9814 16.205C11.9814 16.8906 12.501 17.3717 13.0548 17.3717H15.2481C15.6567 17.3717 16.0648 17.0128 16.0648 16.4617C16.0648 16.0585 15.9775 15.908 15.9308 15.8482C15.8765 15.7786 15.7692 15.6936 15.4938 15.5953L11.9797 14.3694C11.5741 14.225 11.1021 13.9995 10.7493 13.5502C10.3882 13.0904 10.2431 12.5154 10.2431 11.8534C10.2431 10.4366 11.348 9.19336 12.8098 9.19336H15.0031C16.596 9.19336 17.8264 10.5322 17.8264 12.11C17.8264 12.5933 17.4347 12.985 16.9514 12.985C16.4682 12.985 16.0764 12.5933 16.0764 12.11C16.0764 11.4245 15.557 10.9434 15.0031 10.9434H12.8098Z",
    fill: "url(#paint1_linear_560_360)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0234 8.02661C14.5066 8.02661 14.8984 8.41833 14.8984 8.90161V19.4132C14.8984 19.8965 14.5066 20.2882 14.0234 20.2882C13.5402 20.2882 13.1484 19.8965 13.1484 19.4132V8.90161C13.1484 8.41833 13.5402 8.02661 14.0234 8.02661Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0234 8.02661C14.5066 8.02661 14.8984 8.41833 14.8984 8.90161V19.4132C14.8984 19.8965 14.5066 20.2882 14.0234 20.2882C13.5402 20.2882 13.1484 19.8965 13.1484 19.4132V8.90161C13.1484 8.41833 13.5402 8.02661 14.0234 8.02661Z",
    fill: "url(#paint2_linear_560_360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_560_360",
    x1: 26.2263,
    y1: 13.5269,
    x2: 9.18457,
    y2: 13.5269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306EE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_560_360",
    x1: 18.1067,
    y1: 13.9459,
    x2: 12.4174,
    y2: 13.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306EE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_560_360",
    x1: 14.963,
    y1: 13.8961,
    x2: 13.6521,
    y2: 13.8961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306EE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4BA1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroCost2);
export default __webpack_public_path__ + "static/media/Zero_cost_2.7aa2c812255d5f783eaa80d3e26361cf.svg";
export { ForwardRef as ReactComponent };